import HandymanIcon from '@mui/icons-material/Handyman'
import { haveRole } from '@/lib/admin/getIsUserBackOffice'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { CONSTANTS } from '@/types/enum/constants'
import { CountryEnum } from '@/types/enum/enumUser'

/**
 * Explorateur Donnees — entree TRANSVERSE, ouverte a TOUS les admins back-office
 * (School, Insight, Sound, Store, PLV, Call...), pas seulement aux super admins.
 *
 * Perimetre reel cote API (S3ExplorerAccessService) : les admins non super voient le
 * SEUL bucket public PMG, qu'ils peuvent consulter et alimenter ; le bucket prive et
 * la recherche ELS restent reserves aux super admins.
 *
 * France uniquement (cf. .claude/rules/country-scope-front.md) : le super admin garde
 * l'acces sans condition de pays, comportement inchange depuis la creation de la page.
 */
export const routeBackOfficeAdminToolsCommon = [
  {
    route: 'AdminTools',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Explorateur Données',
    icon: HandymanIcon,
    href: '/backoffice/group/admin-tools',
    menuHeader: true,
    position: 950,
    fnDisplay: ({ dataMyProfile }) =>
      haveRole(dataMyProfile?.loggedUserRoles ?? [], [CONSTANTS.ROLE_SUPER_ADMIN]) ||
      !!dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
]
